/**
 * Bildschirm wachhalten (Screen Wake Lock API).
 *
 * Safari auf iPadOS unterstuetzt das seit 16.4. Faellt die Sperre weg
 * (z. B. nach dem Wechsel in eine andere App), wird sie beim Zurueckkommen
 * automatisch neu angefordert.
 */

export interface WakeLock {
  release(): void;
}

export function keepAwake(): WakeLock {
  let sentinel: WakeLockSentinel | null = null;
  let released = false;

  const request = async () => {
    if (released) return;
    if (!('wakeLock' in navigator)) return;
    try {
      sentinel = await navigator.wakeLock.request('screen');
      sentinel.addEventListener('release', () => {
        sentinel = null;
      });
    } catch {
      // Kein Wake Lock moeglich (z. B. Akku-Sparmodus) – kein Fehlerfall.
    }
  };

  const onVisibility = () => {
    if (document.visibilityState === 'visible' && !sentinel) void request();
  };

  document.addEventListener('visibilitychange', onVisibility);
  void request();

  return {
    release() {
      released = true;
      document.removeEventListener('visibilitychange', onVisibility);
      void sentinel?.release();
      sentinel = null;
    },
  };
}
